// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#temp-copy-right[data-v-243dd5b1] {\n    display: block;\n    position: absolute;\n    left: 50vw;\n    bottom: 10px;\n    z-index: 10000;\n}\n", ""]);
// Exports
module.exports = exports;
